/**
 * SafeHtmlContent — renders sanitized HTML with prose styling.
 *
 * Security: uses DOMPurify to strip XSS vectors before injecting HTML.
 * Styling: uses Tailwind Typography's `prose` for consistent rich-text output.
 */

import React, { useMemo } from "react";
import DOMPurify from "dompurify";
import { cn } from "../../utils/cn";

export interface SafeHtmlContentProps {
  /** Raw HTML string to render (e.g. TipTap editor output) */
  html: string;
  /** Additional class names for the wrapper */
  className?: string;
}

export default function SafeHtmlContent({
  html,
  className,
}: SafeHtmlContentProps) {
  const sanitized = useMemo(() => DOMPurify.sanitize(html), [html]);

  return (
    <div
      className={cn(
        "prose prose-slate max-w-none prose-headings:text-slate-900 prose-p:text-slate-700 prose-li:text-slate-700 prose-strong:text-slate-900 prose-a:text-blue-600",
        className,
      )}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
